module.exports = __webpack_public_path__ + "static/img/nongyao.9bbbe28f.svg";